import '../sass/testimonials.scss';

(() => {
    const swiperScript = document.querySelector('#point-to-point-swiper-js');
    const $blocks = document.querySelectorAll('.testimonials');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $carousel = $block.querySelector('.testimonials__carousel');
        const $navigationPrevious = $block.querySelector('.testimonials__carousel-nav-prev');
        const $navigationNext = $block.querySelector('.testimonials__carousel-nav-next');

        const initCarousel = () => {
            if (!$carousel) return;

            const swiper = new Swiper($carousel, {
                slidesPerView: 'auto',
                navigation: {
                    prevEl: $navigationPrevious,
                    nextEl: $navigationNext
                },
                allowTouchMove: false,
                autoHeight: true,
                loop: true
            });
        };

        if (typeof Swiper !== 'undefined') { 
            initCarousel();
        } else {
            swiperScript.addEventListener('load', () => {
                initCarousel();
            });
        }
    });
})();
